const MonthlyPrice = "3.99";
const InAppMonthlyPrice = "4.99";

export function getMonthlyPrice(priceOverride?: string): string {
  if (priceOverride) {
    return priceOverride;
  }
  return isInsideAppleAppStoreApp() ? InAppMonthlyPrice : MonthlyPrice;
}

// IMPORTANT: This doesn't actually work inside an iframe (cannot view parent globals)
export function isInsideAppleAppStoreApp() {
  // @ts-ignore
  return Boolean(window.webkit);
}
